import {PROJECTS, settings} from '@/src/config/settings'

let platform: string = 'web'
let platformPromise: Promise<string> | null = null

export const initPlatform = (): Promise<string> => {
  if (!platformPromise) {
    platformPromise = import('@capacitor/core').then(({Capacitor}) => {
      platform = Capacitor.getPlatform()
      return platform
    })
  }
  return platformPromise
}

export const isMobile = () =>
  (process.env.NODE_ENV === 'production' && ['android', 'ios'].includes(platform)) ||
  settings.PROJECT === PROJECTS.Mobile

export const isIOS = () => platform === 'ios'
